import React from 'react';
import axios from 'axios';
import LOADER_IMG from './loader.svg';
import style from './styles.css';
import RequisitionsLoader from './RequisitionsLoader';
import Dialog from '../../components/alert/Dialog';
const Requisitions = (props) => {

  RequisitionsLoader.createLoader();

  axios({
    mode: 'no-cors',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
    credentials: 'same-origin',
    method: 'post',
    url: props.url,
    data: props.data
  })
  .then(function (response) {
    const data = response.data;

    if(data.sessionClosed){
      RequisitionsLoader.removeLoader();
      const msg = {
        title: 'Atenção',
        text: data.msg,
        onSubmit: () => {
          window.localStorage.removeItem('usuario');
          window.localStorage.removeItem('senha');
          window.location.href = '/';
        }
      };
      Dialog.create(msg);
      return false;
    }
    if(props.sucess){
      if(data.expired){
        //window.location.href = '/';
      }else{
        //props.sucess(response.data);
      }
      props.sucess(response.data);
    }
    RequisitionsLoader.removeLoader();
  })
  .catch(function (error) {
    if(props.error){
      props.error(error);
    }
    RequisitionsLoader.removeLoader();
  });
  // Post a user
}

export const Get = (props) => {
  RequisitionsLoader.createLoader();
  axios.get(props.url)
  .then(function(response){
    if(props.sucess){
      props.sucess(response.data);
    }
    RequisitionsLoader.removeLoader();
  });
}

export default Requisitions;



// WEBPACK FOOTER //
// ./src/utils/requisitions/Requisitions.js